// Booking-date helpers. The bookings.date and blocked_times.date columns are
// stored as ISO YYYY-MM-DD strings (post-migration 005). Every consumer in the
// app should go through these helpers — never split or parse the string inline.

const MONTH_NAMES_FULL = [
  "January", "February", "March",     "April",   "May",      "June",
  "July",    "August",   "September", "October", "November", "December",
];

// (year, monthIndex 0-11, day) → "2026-06-05"
export function toIsoDate(year, monthIndex, day) {
  const mm = String(monthIndex + 1).padStart(2, "0");
  const dd = String(day).padStart(2, "0");
  return `${year}-${mm}-${dd}`;
}

// "2026-06-05" → { year, month: 0-11, day } | null
export function parseIsoDate(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || "");
  if (!m) return null;
  return { year: parseInt(m[1], 10), month: parseInt(m[2], 10) - 1, day: parseInt(m[3], 10) };
}

// "2026-06-05" → "June 5, 2026", suitable for display.
// Falls back to the input if it's already in legacy "Month D, YYYY" form
// (so a stale browser session viewing pre-migration data still renders sensibly).
export function formatDate(iso) {
  if (!iso) return "";
  if (/^[A-Za-z]+ \d{1,2}, \d{4}$/.test(iso)) return iso; // legacy passthrough
  const parts = parseIsoDate(iso);
  if (!parts) return iso;
  return `${MONTH_NAMES_FULL[parts.month]} ${parts.day}, ${parts.year}`;
}
